// extracted by mini-css-extract-plugin
module.exports = {"sms":"SMS_sms__Myj_P"};